import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const MoreHorizCircleSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default MoreHorizCircleSVG;
